import urls from "global/constants/UrlConstants";
import { getCallParams, getFileCallParams, makeCall } from "utils/service";
import { store } from "utils/store";

export const fetchProfileDetails = async () => {
  try {
    const email = store.getState().auth.email;
    const url = `${urls.GET_USER_PROFILE}/${email}`;
    const callParams = await getCallParams("GET");
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateProfilePicture = async (file: any) => {
  try {
    const url = urls.UPDATE_PROFILE_PICTURE;
    const callParams = await getFileCallParams("PATCH", file);
    const response: any = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const removeProfilePicture = async () => {
  try {
    const callParams = await getCallParams("PATCH");
    const response: any = await makeCall(
      urls.REMOVE_PROFILE_PICTURE,
      callParams
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
